import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";
import Select from "react-select";
import {authenticationService} from "../../services/AuthenticationService";
import FormElementContainerWithoutTitle from "../forms_builder/FormElementContainerWithoutTitle";
import TreatmentIntakeMethod from "./TreatmentIntakeMethod";
import TreatmentCategory from "./TreatmentCategory";
import TreatmentVariety from "./TreatmentVariety";
import FormElementContainerHeight from "../forms_builder/FormElementContainerHeight";
import TreatmentProduct from "./TreatmentProduct";
import TreatmentDosage from "./TreatmentDosage";
import TreatmentPlan from "./TreatmentPlan";
import SvGraphics from "../../assets/SvGraphics";
import {doctorApi} from "../../services/ApiService";

class TreatmentPlanBlock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            view: 1,
        }
    }

    componentDidMount() {
    }

    changeView = (num) => {
        this.setState({view: this.state.view === num ? 0 : num});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    editTreatmentPlan = (func, value, index) => {
        this.props.editTreatmentPlan(func, value, index)
    }

    DeleteTreatment(index) {
        this.props.DeleteTreatment(index)
    }

    getTitrationPlan(val, index) {
        this.props.getTitrationPlan(val, index)
    }

    setTitrationSchedule(val, index) {
        this.props.setTitrationSchedule(val, index)
    }

    getTargetSymptoms(index, current) {
        let targetSymptoms = this.props.symptoms
        let symptomsList = this.props.symptomsList
        let targetSymptomsChoosen = []
        let language = localStorage.getItem('language')

        targetSymptoms = targetSymptoms ? targetSymptoms : []
        for (let j = 0; j < targetSymptoms.length; j++) {
            if (targetSymptoms[j].Symptom_ID) {
                for (let i = 0; i < symptomsList.length; i++) {
                    if (symptomsList[i].Symptom_ID.toString() === targetSymptoms[j].Symptom_ID.substring(1)) {
                        targetSymptomsChoosen.push(
                            <div className={'checkbox-label'}>
                                <input type={"checkbox"} className={"checkboxStyle-treatment-symptoms"}
                                       onClick={(event) => this.editTreatmentPlan("Symptom_ID", symptomsList[i].Symptom_ID, index)}
                                       checked={current.Symptom_ID ? current.Symptom_ID.includes(symptomsList[i].Symptom_ID) : ""}
                                       onChange={()=>{}}
                                />
                                {language === "he" ?
                                    <label
                                        className={'treatment_plan_symptom_label'}>{symptomsList[i].Symptom_description_he}</label> :
                                    <label
                                        className={'treatment_plan_symptom_label'}>{symptomsList[i].Symptom_description}</label>
                                }
                            </div>
                        )
                    }
                }
            }
        }
        return targetSymptomsChoosen
    }


    render() {
        let {t, treatmentIndex, current,doctorName} = this.props
        let targetSymptoms = this.props.symptoms

        let {view} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')


        let intakeMethod = current.TreatmentIntakeMethod
        let variety = current.TreatmentVariety
        let treatmentSchedule = current.TreatmentSchedule
        if (language === "he") {
            treatmentSchedule = treatmentSchedule === "As needed" ? "לפי צורך" : treatmentSchedule
            treatmentSchedule = treatmentSchedule === "Maintenance" ? "המשך טיפול" : treatmentSchedule
            treatmentSchedule = treatmentSchedule === "Titration" ? "טיטרציה" : treatmentSchedule
            intakeMethod = intakeMethod === "Flower" ? "פרח" : intakeMethod
            intakeMethod = intakeMethod === "Oil drops" ? "טיפות שמן" : intakeMethod
            intakeMethod = intakeMethod === "Precision Dosing Devices" ? "משאף למינון מדוד" : intakeMethod
            intakeMethod = intakeMethod === "Other" ? "אחר" : intakeMethod
            variety = variety === "Indica" ? "אינדיקה" : variety
            variety = variety === "Sativa" ? "סאטיבה" : variety
            variety = variety === "Blend" ? "זן היברידי" : variety
            variety = variety === "Select All" ? "אינדיקה, סאטיבה, זן היברידי" : variety
        } else {
            variety = variety === "Select All" ? "Indica, Sativa, Blend" : variety
        }
        return (

            <div className={'adminMarginTreatmentPlan'}>
                <div className={'treatmentPlanRowBlock'}>
                    {targetSymptoms && <label
                        className="treatment-plan-boxes-target-label"> {t('patient_boarding.target_symptoms')}:</label>}
                    {this.getTargetSymptoms(treatmentIndex, current)}

                    {  doctorName &&<div>
                    <label>{t('patient_boarding.Recommended_doc')}:</label>
                    <label>{" " + doctorName}</label>
                </div>}
                </div>

                <div className={'adminMarginTreatmentPlan'}>
                    <div className={view === 1 ? 'treatmentPlanTabs' : 'treatmentPlanTabsUnselected'}
                         style={{display: 'flex'}}>
                        <div className={view === 1 ? 'treatmentPlanTabsCurrBox' : 'treatmentPlanTabsBoxes'}
                             onClick={() => this.changeView(1)}>
                            <span
                                className={view === 1 ? "treatment-plan-category-selected" : "treatment-plan-category"}
                                style={{display: current.TreatmentIntakeMethod && view !== 1 ? 'none' : 'inline'}}>1</span>

                            <SvGraphics svgname={'check-icon-white'} style={{
                                display: current.TreatmentIntakeMethod && view !== 1 ? 'block' : 'none',
                                width: '20px', height: '20px'
                            }}/>


                            <label className="treatment-plan-category-label"
                                   style={{display: view === 1 ? 'block' : 'none'}}>{t('patient_boarding.Intake_method')}</label>
                        </div>

                        <div className="treatment-plan-not-selected-block"
                             style={{display: view !== 1 ? 'flex' : 'none'}}>
                            <div style={{display: 'flex', width: '95%'}}>
                                <div
                                    className={"treatment-plan-boxes-title-not-selected"}>{t('patient_boarding.Intake_method')} </div>
                                <div className={"slash-div"}/>
                                <div className="treatment-plan-not-selected-value"> {intakeMethod} </div>
                            </div>
                            <SvGraphics svgname={'pencil'} style={{height: '19px', width: '19px', cursor: 'pointer'}}
                                        onClick={() => this.changeView(1)}/>
                        </div>
                        <FormElementContainerWithoutTitle
                            Component={TreatmentIntakeMethod}
                            rest={{
                                onValueChange: (name, value) => this.onValueChange(name, value),
                                entry: this.props.entry,
                                errors: this.props.errors,
                                view: view,
                                current: current,
                                changeView: (num) => this.changeView(num),
                                index: treatmentIndex,
                                editTreatmentPlan: (func, value, index) => this.editTreatmentPlan(func, value, index),
                                t: (e) => this.props.t(e)
                            }}/>
                    </div>

                    <div className={view === 2 ? 'treatmentPlanTabs' : 'treatmentPlanTabsUnselected'}
                         style={{display: 'flex'}}>
                        <div className={view === 2 ? 'treatmentPlanTabsCurrBox' : 'treatmentPlanTabsBoxes'}
                             onClick={() => this.changeView(2)}>
                            <span
                                className={view === 2 ? "treatment-plan-category-selected" : "treatment-plan-category"}
                                style={{display: current.TreatmentCategory && view !== 2 ? 'none' : 'inline'}}>2</span>

                            <SvGraphics svgname={'check-icon-white'} style={{
                                display: current.TreatmentCategory && view !== 2 ? 'block' : 'none',
                                width: '20px', height: '20px'
                            }}/>
                            <label className="treatment-plan-category-label"
                                   style={{display: view === 2 ? 'block' : 'none'}}>{t('patient_boarding.Category')}</label>
                        </div>
                        <div className="treatment-plan-not-selected-block"
                             style={{display: view !== 2 ? 'flex' : 'none'}}>
                            <div style={{display: 'flex', width: '95%'}}>
                                <div
                                    className={"treatment-plan-boxes-title-not-selected"}> {t('patient_boarding.Category')}</div>
                                <div className={"slash-div"}/>
                                <div className="treatment-plan-not-selected-value"> {current.TreatmentCategory} </div>
                            </div>
                            <SvGraphics svgname={'pencil'} style={{height: '19px', width: '19px', cursor: 'pointer'}}
                                        onClick={() => this.changeView(2)}/>
                        </div>
                        <FormElementContainerWithoutTitle
                            Component={TreatmentCategory}
                            rest={{
                                onValueChange: (name, value) => this.onValueChange(name, value),
                                entry: this.props.entry,
                                errors: this.props.errors,
                                changeView: (num) => this.changeView(num),
                                current: current,
                                view: view,
                                index: treatmentIndex,
                                editTreatmentPlan: (func, value, index) => this.editTreatmentPlan(func, value, index),
                                t: (e) => this.props.t(e)
                            }}/>
                    </div>

                    <div className={view === 3 ? 'treatmentPlanTabs' : 'treatmentPlanTabsUnselected'}
                         style={{display: 'flex'}}>
                        <div className={view === 3 ? 'treatmentPlanTabsCurrBoxDosage' : 'treatmentPlanTabsBoxes'}
                             onClick={() => this.changeView(3)}>
                           <span
                               className={view === 3 ? "treatment-plan-category-selected" : "treatment-plan-category"}
                               style={{display: current.TreatmentSchedule && view !== 3 ? 'none' : 'inline'}}>3</span>

                            <SvGraphics svgname={'check-icon-white'} style={{
                                display: current.TreatmentSchedule && view !== 3 ? 'block' : 'none',
                                width: '20px', height: '20px'
                            }}/>
                            <label className="treatment-plan-category-label"
                                   style={{display: view === 3 ? 'block' : 'none'}}>{t('patient_boarding.Dosage')}</label>

                        </div>
                        <div className="treatment-plan-not-selected-block"
                             style={{display: view !== 3 ? 'flex' : 'none'}}>
                            <div style={{display: 'flex', width: '95%'}}>
                                <div
                                    className={"treatment-plan-boxes-title-not-selected"}> {t('patient_boarding.Dosage')}</div>
                                <div className={"slash-div"}/>

                                <label
                                    className="treatment-plan-not-selected-value"> {t('patient_boarding.MonthlyDose')} :{current.TreatmentMonthlyDosage} </label>
                                <label
                                    className="treatment-plan-not-selected-value"> {t('patient_boarding.Initial_dose')} :{current.TreatmentInitialDose} </label>
                                <label
                                    className="treatment-plan-not-selected-value">{t('patient_boarding.Maximum_daily_dose')}
                                    :{current.Treatment_Maximum_dosage}</label>
                            </div>
                            <SvGraphics svgname={'pencil'} style={{height: '19px', width: '19px', cursor: 'pointer'}}
                                        onClick={() => this.changeView(3)}/>

                        </div>
                        <FormElementContainerWithoutTitle
                            Component={TreatmentDosage}
                            rest={{
                                onValueChange: (name, value) => this.onValueChange(name, value),
                                entry: this.props.entry,
                                errors: this.props.errors,
                                isTitrationSchedule: this.state.isTitrationSchedule,
                                titrationPlan: this.props.titrationPlan,
                                titrationPlans: this.props.titrationPlans,
                                current: current,
                                view: view,
                                index: treatmentIndex,
                                changeView: (num) => this.changeView(num),
                                editTreatmentPlan: (func, value, index) => this.editTreatmentPlan(func, value, index),
                                getNewTitration: (initialDose, maxDosage, stepEach) => this.getNewTitration(initialDose, maxDosage, stepEach),
                                setTitrationSchedule: (val, index) => this.setTitrationSchedule(val, index),
                                getTitrationPlan: (val, index) => this.getTitrationPlan(val, index),
                                t: (e) => this.props.t(e)

                            }}/>
                    </div>

                    <div className={view === 4 ? 'treatmentPlanTabs' : 'treatmentPlanTabsUnselected'}
                         style={{display: 'flex'}}>
                        <div className={view === 4 ? 'treatmentPlanTabsCurrBox' : 'treatmentPlanTabsBoxes'}
                             onClick={() => this.changeView(4)}>
                           <span
                               className={view === 4 ? "treatment-plan-category-selected" : "treatment-plan-category"}
                               style={{display: current.TreatmentVariety && view !== 4 ? 'none' : 'inline'}}>4</span>

                            <SvGraphics svgname={'check-icon-white'} style={{
                                display: current.TreatmentVariety && view !== 4 ? 'block' : 'none',
                                width: '20px', height: '20px'
                            }}/>
                            <label className="treatment-plan-category-label"
                                   style={{display: view === 4 ? 'block' : 'none'}}>{t('patient_boarding.Variety')}</label>
                        </div>
                        <div className="treatment-plan-not-selected-block"
                             style={{display: view !== 4 ? 'flex' : 'none'}}>

                            <div style={{display: 'flex', width: '95%'}}>
                                <div
                                    className={"treatment-plan-boxes-title-not-selected"}> {t('patient_boarding.Variety')}</div>
                                <div className={"slash-div"}/>
                                <div
                                    className="treatment-plan-not-selected-value"> {variety} </div>
                            </div>
                            <SvGraphics svgname={'pencil'} style={{height: '19px', width: '19px', cursor: 'pointer'}}
                                        onClick={() => this.changeView(4)}/>
                        </div>
                        <FormElementContainerWithoutTitle
                            Component={TreatmentVariety}
                            rest={{
                                onValueChange: (name, value) => this.onValueChange(name, value),
                                entry: this.props.entry,
                                errors: this.props.errors,
                                current: current,
                                view: view,
                                changeView: (num) => this.changeView(num),
                                index: treatmentIndex,
                                editTreatmentPlan: (func, value, index) => this.editTreatmentPlan(func, value, index),
                                t: (e) => this.props.t(e)

                            }}/>
                    </div>

               {/*     <div className={view === 5 ? 'treatmentPlanTabs' : 'treatmentPlanTabsUnselected'}
                         style={{display: 'flex'}}>
                        <div className={view === 5 ? 'treatmentPlanTabsCurrBoxProd' : 'treatmentPlanTabsBoxes'}
                             onClick={() => this.changeView(5)}>
                            <span
                                className={view === 5 ? "treatment-plan-category-selected" : "treatment-plan-category"}
                                style={{display: current.Treatment_plan_selected_product && view !== 5 ? 'none' : 'inline'}}>5</span>

                            <SvGraphics svgname={'check-icon-white'} style={{
                                display: current.Treatment_plan_selected_product && view !== 5 ? 'block' : 'none',
                                width: '20px', height: '20px'
                            }}/>
                            <label className="treatment-plan-category-label"
                                   style={{display: view === 5 ? 'block' : 'none'}}>{t('patient_boarding.Product')}</label>
                        </div>
                        <div className="treatment-plan-not-selected-block"
                             style={{display: view !== 5 ? 'flex' : 'none'}}>
                            <div style={{display: 'flex', width: '95%'}}>
                                <div
                                    className={"treatment-plan-boxes-title-not-selected"}> {t('patient_boarding.Product')}</div>
                                <div className={"slash-div"}/>
                                <div
                                    className="treatment-plan-not-selected-value"> {current.Treatment_plan_selected_product} </div>
                            </div>
                            <SvGraphics svgname={'pencil'} style={{height: '19px', width: '19px', cursor: 'pointer'}}
                                        onClick={() => this.changeView(5)}/>

                        </div>
                        <FormElementContainerWithoutTitle
                            Component={TreatmentProduct}
                            rest={{
                                onValueChange: (name, value) => this.onValueChange(name, value),
                                entry: this.props.entry,
                                errors: this.props.errors,
                                view: view,
                                current: current,
                                changeView: (num) => this.changeView(num),
                                index: treatmentIndex,
                                editTreatmentPlan: (func, value, index) => this.editTreatmentPlan(func, value, index),
                                productsList: this.props.productsList,
                                t: (e) => this.props.t(e)

                            }}/>
                    </div>
*/}
                </div>

            </div>

        )
    }
}

TreatmentPlanBlock.propTypes = {
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default TreatmentPlanBlock;
